import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCookie, loadScriptsSequentially } from '../utils';
import { useModal } from '../backend/ModalContext';
import { Slide } from 'react-toastify';
import SliderTotemInfo from '../components/SliderTotemInfo';
import AnchorScrollingTotemInfo from '../components/AnchorScrollingTotemInfo';

function TotemInfo() {
    // const [sites, setSites] = useState([]);
    const [faqCategories, setFaqCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState(null);
    const { openModal } = useModal(); // Usa la funzione per aprire il modal



    useEffect(() => {
        // Carica jQuery e altri script necessari
        const script = document.createElement('script');
        script.src = "https://app.huberway.org/assets/plugins/jquery/jquery-3.2.1.min.js?v=" + Date.now();
        script.onload = () => {
            loadScriptsSequentially([
                "js/pre-loader.js",
                "assets/bootstrap/js/popper.min.js",
                "assets/bootstrap/js/bootstrap.min.js",
                "js/parallaxie.js",
                "js/TweenMax.min.js",
                "js/jquery.wavify.js",
                "assets/wow/wow.min.js",
                "assets/counterup/jquery.counterup.min.js",
                "assets/counterup/jquery.waypoints.min.js",
                "js/main.js",
            ]);
        };

        document.body.appendChild(script);

        // Fetch FAQs from API
        fetch('https://psicopatici.com/api/v1/faqs/categories')
            .then(response => response.json())
            .then(data => {
                setFaqCategories(data.data);
                setLoading(false);
                setActiveCategory(6);
            })
            .catch(error => {
                console.error('Error fetching FAQs:', error);
                setLoading(false);
            });

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const handleCategoryClick = (categoryId) => {
        setActiveCategory(categoryId);
    };

    return (
        <>
            <section className="doc_banner_area_two" style={{height: "450px"}}>
                <div className="b_plus one" data-parallax='{"x": 250, "y": 160, "rotateZ":500}'><img src="img/home_two/plus.png"
                    alt="" /></div>
                <div className="b_plus two" data-parallax='{"x": 250, "y": 260, "rotateZ":500}'><img src="img/home_two/plus_one.png"
                    alt="" /></div>
                <div className="b_round r_one" data-parallax='{"x": 0, "y": 100, "rotateZ":0}'></div>
                <div className="b_round r_two" data-parallax='{"x": -10, "y": 80, "rotateY":0}'></div>
                <div className="b_round r_three"></div>
                <div className="b_round r_four"></div>
                <img className="p_absolute building_img" src="img/home_two/building.png" alt="" />
                <img className="p_absolute table_img wow fadeInLeft" src="img/home_two/table.svg" alt="" />
                <img className="p_absolute flower wow fadeInUp" data-wow-delay="0.6s" src="img/home_two/flower.png" alt="" />
                <img style={{width: "150px", marginBottom: "14px"}} className="p_absolute bord wow fadeInRight" data-wow-delay="0.8s" src="img/totem.png" alt="" />
                <img className="p_absolute girl wow fadeInRight" data-wow-delay="0.8s" src="img/home_two/girl.png" alt="" />
                <div className="container">
                    <div className="doc_banner_text_two text-center">
                        <h1 style={{fontWeight: "500"}}>Totem: Sistema di Commissioni, Sicurezza e Integrazione CRM</h1>
                        <p>Scopri come funziona il nostro sistema di commissioni e percentuali, come gestiamo le statistiche e come integrare la sicurezza e le notifiche nel nostro CRM Affiliati.</p>
                    </div>
                </div>
            </section>
            <AnchorScrollingTotemInfo/>
            <SliderTotemInfo />

            <section className="doc_faq_area_two sec_pad">
                <div className="container">
                    <div className="section_title text-center">
                        <h2 className="h_title wow fadeInUp">Domande più frequenti (FAQ)</h2>
                        {/* <p className="wow fadeInUp" data-wow-delay="0.2s">Here are some common questions and answers.</p> */}
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-5">
                            <div className="fact_navigation_info">
                                <h4 className="c_head">Categorie</h4>
                                <ul className="nav nav-tabs fact_navigation" id="myTab" role="tablist">
                                    {faqCategories.map((category) => (
                                        <li className="nav-item" key={category.id}>
                                            <Link
                                                className={`nav-link ${activeCategory === category.id ? 'active' : ''}`}
                                                id={`${category.id}-tab`}
                                                to={`#${category.id}`}
                                                role="tab"
                                                aria-controls={category.id}
                                                aria-selected={activeCategory === category.id}
                                                onClick={() => handleCategoryClick(category.id)}
                                            >
                                                <i className="icon_folder-alt"></i>{category.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-7">
                            <div className="tab-content pl_70" id="myTabContent">
                                {faqCategories.map((category) => (
                                    <div
                                        key={category.id}
                                        className={`tab-pane faq_tab_pane fade ${activeCategory === category.id ? 'show active' : ''}`}
                                        id={category.id}
                                        role="tabpanel"
                                        aria-labelledby={`${category.id}-tab`}
                                    >
                                        <div className="accordion doc_faq_info" id={`accordion${category.id}`}>
                                            {category.faqs.map((faq, faqIndex) => (
                                                <div className="card wow fadeInUp" key={faq.id} data-wow-delay={`${faqIndex * 0.1}s`}>
                                                    <div className="card-header" id={`heading${faq.id}`}>
                                                        <h2 className="mb-0">
                                                            <button
                                                                className="btn btn-link"
                                                                type="button"
                                                                data-toggle="collapse"
                                                                data-target={`#collapse${faq.id}`}
                                                                aria-expanded={faqIndex === 0}
                                                                aria-controls={`collapse${faq.id}`}
                                                            >
                                                                {faq.question}<i className="icon_plus"></i><i className="icon_minus-06"></i>
                                                            </button>
                                                        </h2>
                                                    </div>
                                                    <div
                                                        id={`collapse${faq.id}`}
                                                        className={`collapse ${faqIndex === 0 ? 'show' : ''}`}
                                                        aria-labelledby={`heading${faq.id}`}
                                                        data-parent={`#accordion${category.id}`}
                                                    >
                                                        <div className="card-body">
                                                            <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default TotemInfo;

